import { render, staticRenderFns } from "./alertWidget.vue?vue&type=template&id=38629ecd&scoped=true"
import script from "./alertWidget.vue?vue&type=script&lang=js"
export * from "./alertWidget.vue?vue&type=script&lang=js"
import style0 from "./alertWidget.vue?vue&type=style&index=0&id=38629ecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38629ecd",
  null
  
)

export default component.exports